export const PERCENTAGE_BAND_COLORS = [
  // Alternating between blues, purples, and oranges for maximum contrast
  'rgba(0, 122, 255, 0.7)', // Bright Blue
  'rgba(148, 0, 211, 0.7)', // Dark Violet
  'rgba(255, 165, 0, 0.7)', // Orange
  'rgba(0, 199, 190, 0.7)', // Teal
  'rgba(0, 119, 182, 0.7)', // Deep Blue
  'rgba(147, 112, 219, 0.7)', // Medium Purple
  'rgba(255, 127, 80, 0.7)', // Coral
  'rgba(255, 69, 0, 0.7)', // Red Orange
  'rgba(111, 0, 255, 0.7)', // Electric Indigo
  'rgba(255, 160, 122, 0.7)', // Light Salmon
  'rgba(139, 0, 139, 0.7)', // Dark Magenta
  'rgba(255, 140, 105, 0.7)', // Salmon
  'rgba(0, 150, 199, 0.7)', // Steel Blue
  'rgba(0, 191, 255, 0.7)', // Deep Sky Blue
  'rgba(153, 50, 204, 0.7)', // Dark Orchid
  'rgba(255, 140, 0, 0.7)', // Dark Orange
  'rgba(128, 0, 128, 0.7)', // Purple
  'rgba(0, 168, 132, 0.7)', // Sea Green
  'rgba(147, 51, 234, 0.7)', // Indigo
  'rgba(0, 180, 216, 0.7)', // Ocean Blue
];
